import { render, staticRenderFns } from "./tbmPop.vue?vue&type=template&id=e177fccc"
import script from "./tbmPop.vue?vue&type=script&lang=js"
export * from "./tbmPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e177fccc')) {
      api.createRecord('e177fccc', component.options)
    } else {
      api.reload('e177fccc', component.options)
    }
    module.hot.accept("./tbmPop.vue?vue&type=template&id=e177fccc", function () {
      api.rerender('e177fccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmPop.vue"
export default component.exports